import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';
import IntlMessages from '@jumbo/utils/IntlMessages';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnRoot: {
    [theme.breakpoints.down('xs')]: {
      padding: '6px 12px',
      fontSize: 11,
    },
  },
}));

const Footer = props => {
  const classes = useStyles();
  const { themeType } = useContext(AppContext);
  const date = new Date();

  return (
    <Box className={classes.root} {...props}>
      <Box display="flex" alignItems="center">
        <Box fontSize={{ xs: 12, sm: 14 }} component="p" color="text.disabled">
          Copyright <IntlMessages id="copyright.company.name" /> © {date.getFullYear()}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
